import React from 'react'
import PropTypes from 'prop-types'
import { AppliedTooltip as Tooltip, PopoverContainer, BaseSpan } from '../AppliedTooltip/AppliedTooltip'
import styles from './CapsSpan.module.css'


class CapsSpan extends React.Component {

    handleClick(word) {
        this.props.addWordToIgnoreList({word, block : this.props.children[0].props.block.getKey()})
    }

    popoverTop = (
        <PopoverContainer title="Acronyms" color="#FF38DF">
            <div>Using acronyms can make your meaning unclear, make sure to explain them
            if they're not commonly used</div>
            <div className={styles.buttonRow} onClick={() => this.handleClick(this.props.decoratedText)}>
                <div className={styles.button}>Ignore</div>
            </div>
        </PopoverContainer>
    )

    render() {
        return (
            <span>
                <Tooltip
                    popoverContent={this.popoverTop}
                    disabled={!this.props.user.userId}
                >
                    <BaseSpan
                        offsetKey={this.props.offsetKey}
                        disabled={!this.props.user.userId}
                        color="#FFB9EC"
                        borderColor="#FF38DF"
                    >
                        {this.props.children}
                    </BaseSpan>
                </Tooltip>
            </span>
        )
    }
}

CapsSpan.propTypes = {
    children: PropTypes.array,
}

export default CapsSpan
